import { render, staticRenderFns } from "./StatsPriceIndicationsStatusHeatmap.vue?vue&type=template&id=2c069d4f"
import script from "./StatsPriceIndicationsStatusHeatmap.vue?vue&type=script&lang=js"
export * from "./StatsPriceIndicationsStatusHeatmap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports